import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { navLinks } from '../data/mock';
import Logo from './Logo';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header 
      className="header-nav"
      style={{
        boxShadow: isScrolled ? '0 4px 30px rgba(0,0,0,0.3)' : 'none'
      }}
    >
      <Logo size="default" />

      {/* Desktop Navigation */}
      <nav className="hidden md:flex items-center gap-8">
        {navLinks.map((link) => (
          <a
            key={link.label}
            href={link.href}
            className="text-sm font-medium transition-colors hover:text-[var(--accent-primary)]"
            style={{ color: 'var(--text-muted)' }}
          >
            {link.label}
          </a>
        ))}
      </nav>

      <div className="hidden md:flex items-center gap-4">
        <a href="#contact" className="btn-primary">
          Contact Us
        </a>
      </div>

      {/* Mobile Menu Button */}
      <button
        className="md:hidden p-2 rounded-lg transition-colors"
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        style={{ 
          background: 'transparent', 
          border: '1px solid var(--border-primary)',
          color: 'var(--text-primary)'
        }}
      >
        {isMobileMenuOpen ? <X size={20} /> : <Menu size={20} />}
      </button>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div
          className="absolute top-full left-0 right-0 md:hidden"
          style={{
            background: 'var(--bg-overlay)',
            backdropFilter: 'blur(12px)',
            borderBottom: '1px solid var(--border-primary)',
            padding: '1.5rem'
          }}
        >
          <nav className="flex flex-col gap-4">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-base py-2 transition-colors"
                style={{ color: 'var(--text-secondary)' }}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {link.label}
              </a>
            ))}
            <a
              href="#contact"
              className="btn-primary mt-4"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Contact Us
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
